import { gql } from '@apollo/client';

export const SEARCH_TAGS_AND_HEADERS = gql`
  query SearchTags($searchQuery: String!) {
  live_domains(
    where: {
      _or: [
        { domain_tag_associations: { domain_tag: { tag: { _ilike: $searchQuery } } } },
        { 
          domain_header_associations: { 
            domain_header: { 
              _and: [
                { header: { _ilike: $searchQuery } },
                { header: { _nilike: "%csrf_token%" } },
                { header: { _nilike: "%awsalb%" } },
                { header: { _nilike: "%xsrf-token%" } },
                { header: { _nilike: "%nonce%" } }
              ]
            } 
          } 
        }
      ]
    }
  ) {
    id
    domain
    status_code
    redirect_location
    target {
      id
      name
      tier
      organisation {
        name
      }
    }
    ip {
        id
        ip
        cloud_provider_type
        cdn_type
        waf_type
        ip_port_associations {
            port {
                port
            }
            up
            last_up
            first_up
        }
    }
    technology_tags: domain_tag_associations {
      domain_tag {
        tag
      }
    }
    header_tags: domain_header_associations(
      where: {
        domain_header: {
          _and: [
            { header: { _nilike: "%csrf_token%" } },
            { header: { _nilike: "%awsalb%" } },
            { header: { _nilike: "%xsrf-token%" } }
          ]
        }
      }
    ) {
      domain_header {
        header
      }
    }
    domain_title_associations {
      domain_title {
        title
      }
    }
  }
  }
`;

export const GET_TECHNOLOGY_TAGS_WITH_COUNT = gql`
  query GetTechnologyTagsWithCount($since: timestamp) {
  # Get domain tags from the last week with counts
  domain_tag_association(
    where: {
      timestamp: {_gte: $since},
      domain_tag: {
        # Filter out common technologies - negating individual conditions
        _not: {
          _or: [
            { tag: {_ilike: "%aws%"} },
            { tag: {_ilike: "%amazon%"} },
            { tag: {_ilike: "%azure%"} },
            { tag: {_ilike: "%microsoft%"} },
            { tag: {_ilike: "%google%"} },
            { tag: {_ilike: "%cloudflare%"} },
            { tag: {_ilike: "%cloudfront%"} },
            { tag: {_ilike: "%akamai%"} },
            { tag: {_ilike: "%cdn%"} },
            { tag: {_ilike: "%fastly%"} },
            { tag: {_ilike: "%imperva%"} },
            { tag: {_ilike: "%incapsula%"} },
            { tag: {_ilike: "%waf%"} },
            # Additional common technologies
            { tag: {_ilike: "%nginx%"} },
            { tag: {_ilike: "%apache%"} },
            { tag: {_ilike: "%wordpress%"} },
            { tag: {_ilike: "%php%"} },
            { tag: {_ilike: "%jquery%"} },
            { tag: {_ilike: "%bootstrap%"} },
            { tag: {_ilike: "%react%"} },
            { tag: {_ilike: "%vue%"} },
            { tag: {_ilike: "%angular%"} },
            { tag: {_ilike: "%node%"} },
            { tag: {_ilike: "%mongodb%"} },
            { tag: {_ilike: "%mysql%"} },
            { tag: {_ilike: "%python%"} },
            { tag: {_ilike: "%java%"} },
            { tag: {_ilike: "%javascript%"} },
            { tag: {_ilike: "%typescript%"} },
            { tag: {_ilike: "%html%"} },
            { tag: {_ilike: "%recaptcha%"} },
            { tag: {_ilike: "%vpn%"} },
            { tag: {_ilike: "%http/3%"} },
            { tag: {_ilike: "%css%"} }
          ]
        }
      }
    }
  ) {
    domain_tag {
      id
      tag
    }
    timestamp
    # Count of domains with this tag in last week
    live_domain {
      domain
    }
  }
}
`; 